import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormAutocompleteField from 'components/ui/form/FormAutocompleteField';
import FormSelectField from 'components/ui/form/FormSelectField';
import FormCurrencyField from 'components/ui/form/FormCurrencyField';
import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';
import FormDateField from 'components/ui/form/FormDateField';

const validationSchema = yup.object({
  partner_id: yup.number().required("Mas'ul shaxs tanlanishi majburiy"),
  account_id: yup.number().required('Kassani tanlanishi majburiy'),
  sum: yup.number().required('Pul miqdorini kiritish majburiy'),
  valute: yup.number().required('Pul miqdorini kiritish majburiy'),
  date: yup.date().required('Sana'),
});

const AddEditModal = (props) => {
  const { open, setOpen, setRefetch, itemData, setItemData } = props;
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      date: '',
      sum: '',
      valute: '',
      comment: '',
      account_id: '',
      partner_id: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (itemData?.id) {
        submit(
          { type: 'postUpdate', contentType: 'simple' },
          values,
          '/admin/partners-money',
          values.name,
          itemData?.id,
          false,
          handleFinishRequest
        );
      } else
        submit(
          { type: 'post', contentType: 'simple' },
          values,
          '/admin/partners-money',
          values.name,
          null,
          false,
          handleFinishRequest
        );
    },
  });

  useEffect(() => {
    if (itemData?.id)
      formik.setValues({
        sum: itemData?.sum || '',
        valute: itemData?.valute || '',
        comment: itemData?.comment || '',
        account_id: itemData?.account_id || '',
        partner_id: itemData?.partner_id || '',
        date: itemData?.date || '',
      });
  }, [itemData]);

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setItemData({});
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='md'
      PaperProps={{
        className: '!base-border !shadow-none',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !bg-gray-100 !mb-2'
      >
        {itemData?.id ? (
          <span>{t('pulni tahrirlash')}</span>
        ) : (
          <span>{'Pul Chiqarish'}</span>
        )}
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={6} sm={6} xs={12}>
                <FormDateField
                  delay={0}
                  label={'Sanasi'}
                  fieldName='date'
                  formik={formik}
                />
            </Grid>

            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormCurrencyField
                delay={0.1}
                label={'UZB SUM'}
                fieldName='sum'
                formik={formik}
              />
            </Grid>

            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormCurrencyField
                delay={0.1}
                label={'AQSh Valyutasi'}
                fieldName='valute'
                formik={formik}
              />
            </Grid>

            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormAutocompleteField
                delay={0.2}
                label={'Hamkor'}
                fieldName='partner_id'
                formik={formik}
                autocomplete='off'
                path={'/dictionary/partners'}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormSelectField
                delay={0}
                label={'Kassa'}
                fieldName='account_id'
                formik={formik}
                path={'/dictionary/selfaccounts'}
              />
            </Grid>
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormTextField
                delay={0.3}
                label={'Izoh'}
                fieldName='comment'
                rows={4}
                multiline
                formik={formik}
              />
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.4}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddEditModal;
